import { Injectable } from '@angular/core';
import { Observable, of as ObservableOf, of, Subject, BehaviorSubject, ReplaySubject  } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';

import { Role, User, UserAudit, UserName, mailDTO } from '../shared/models/user.model';
import { AddSupplier, HomePageContents, IAMUser, sectionDetails, supplierById, supplierDetails, SupplierDetails } from '../shared/models/admin.model';
import { DataSourceService } from './data-source.service';
import { environment } from 'src/environments/environment';
import { AddEditNotification, DeleteInfo, NotificationFilters } from '../shared/models/notification.model';

@Injectable({
  providedIn: 'root'
})
export class UserRepositoryService {

  private roles: Role[] = null;
  private loggedUserData: ReplaySubject<User> = new ReplaySubject<User>(1);
  private me: User = null;
  private usernames: UserName[] = null;
  private dbadge:string;
  private message:string;
  loggedUserData$: Observable<User> = this.loggedUserData.asObservable();
  editSup= new ReplaySubject<boolean>(1);
  onNewsModalClose= new ReplaySubject<boolean>(1);
  onHomeSectionModalClose= new ReplaySubject<boolean>(1);
  onSolarFormModalClose= new ReplaySubject<boolean>(1);
  notoficationDocSelected= new BehaviorSubject<any>(null);
  closeNotification= new BehaviorSubject<boolean>(null);
  signRedirectUrlError= new BehaviorSubject<boolean>(false);
  isChecked= new BehaviorSubject<boolean>(null);
  isRowChecked= new BehaviorSubject<any>(null);

  appSettingsClose= new BehaviorSubject<boolean>(null);
  isUploadDrawerClose  = new BehaviorSubject<boolean>(null);
  massCommunicationsClose= new BehaviorSubject<boolean>(null);
  constructor(private dataSource: DataSourceService) { }

  
  getMe(): Observable<User> {
    // alert('Repository');
    // if(environment.oauth)
    // {
    //   console.log('Repository');
    //     return this.dataSource.getMe()
    //     .pipe(
    //       tap((user: any) => {
            
    //         this.me = user;
           
         
          
    //         this.loggedUserData.next(this.me);
    //       })
    //     );
    // }else
    // {
    //   return this.dataSource.getMe()
    //   .pipe(
    //     tap((user: any) => {
         
    //       this.me = user;
    //       this.loggedUserData.next(this.me);
    //     })
    //   );
    // }
    return this.dataSource.getMe()
    .pipe(
      tap((user: any) => {
       
        this.me = user;
        this.loggedUserData.next(this.me);
      })
    );
  }

getRequestAccess(businessJustification: string) : Observable<any>
{
  let resultEmail$ = this.dataSource.getAccess(businessJustification)
  .pipe(tap((result: any) => {
  }));
  return resultEmail$;
}
  getDbadgeId(jsonData: string) {
    const parsedJson = JSON.parse(jsonData);
    return parsedJson[environment.claimUrl]; //['http://schemas.cat.com/identity/claims/catloginid'];
    }

  getMeSync(): User {
    return this.me;
  }

  getUserNames(): Observable<UserName[]> {
    let usernames$: Observable<UserName[]>;
    if (this.usernames !== null) {
      usernames$ = ObservableOf(this.usernames);
    } else {
      usernames$ = this.dataSource.getUserNames()
      .pipe(
        map((data: UserName[]) => {
          this.usernames = data;
          return this.usernames;
        }),
        catchError((err) => {
          
          return ObservableOf([]);
        })
      );
    }
    return usernames$;
  }

  // getAllUsers(): Observable<User[]> {
  //   return this.dataSource.getAllUsers();
  // }

  updateUser(user: User): Observable<User> {
    return this.dataSource.updateUser(user);
  }

  createUser(user: User) : Observable<any> {
    return this.dataSource.createUser(user);
  }

  searchIAMWithName(name: string) : Observable<IAMUser> {
    return this.dataSource.searchIAMWithName(name);
  }

  getHomePageContents(): Observable<any> {
    return this.dataSource.getHomePageContents();
  }

  getAllRoles(): Observable<Role[]> {
    let roles$: Observable<Role[]>;
    if (this.roles !== null) {
      roles$ = ObservableOf(this.roles)
    } else {
      roles$ = this.dataSource.getAllRoles()
        .pipe(
          map((data: Role[]) => {
            this.roles = data;
            return this.roles;
          })
        );
    }
    return roles$;
  }

  postMassCommunication(massCommDetails): Observable<mailDTO> {
    return this.dataSource.postMassCommunication(massCommDetails);
  }

    // --------------------- Supplier Management Methods Start ----------------------

  getSuppliersByFilter(id: string): Observable<supplierDetails> {
    return this.dataSource.getSuppliersByFilter(id);
  }

  getSupplierById(Id: string): Observable<supplierById> {
    return this.dataSource.getSuppliersById(Id);
  }

  getSuppliersBySupplierCode(supplierCode: string): Observable<any> {
    return this.dataSource.searchSuppliersBySupplierCode(supplierCode);
  }

  addSupplierInfo(supplierInfo: AddSupplier) : Observable<any> {
    return this.dataSource.addSupplierInfo(supplierInfo);
  }

  editSupplierInfo(supplierInfo: AddSupplier) : Observable<any> {
    return this.dataSource.editSupplierInfo(supplierInfo);
  }

  isSupplierExist(supplierCode: string): Observable<any> {
    return this.dataSource.isSupplierExist(supplierCode);
  }

  getSupplyChainUsers(supplierCode?: string): Observable<any> {
    return this.dataSource.getSupplyChainUsers(supplierCode);
  }

  getSuppliersWithBuyers(): Observable<any> {
    return this.dataSource.getSuppliersWithBuyers();
  }
  
  addAdditionalBuyers(supplierInfo: any) : Observable<any> {
    return this.dataSource.addAdditionalBuyers(supplierInfo);
  }

  replaceAdditionalBuyers(supplierInfo: any) : Observable<any> {
    return this.dataSource.replaceAdditionalBuyers(supplierInfo);
  }

  // --------------------- Supplier Management Methods End ---------------------

  // --------------------- Notification Management Methods Start ----------------------  //

  getNotificationsInfoByUserId(userId?: string): Observable<any> {
    return this.dataSource.getNotificationsInfoByUserId(userId);
  }

  saveNotification(addEditNotification: AddEditNotification): Observable<any> {
    return this.dataSource.saveNotification(addEditNotification);
  }

  updateNotificationReadStatus(dismissNotification:NotificationFilters): Observable<any> {
    return this.dataSource.updateNotificationReadStatus(dismissNotification);
  }

  deleteNotification(deleteDetails: DeleteInfo): Observable<any> {
    return this.dataSource.deleteNotification(deleteDetails);
  }

    // --------------------- ADMIN All Home Page Conents Methods Start ----------------------  //

  // getAllHomePageConents(): Observable<HomePageContents> {
  //   return this.dataSource.getAllHomePageStaticConents();
  // }

  saveStaticContent(contentForm: HomePageContents): Observable<any> {
    return this.dataSource.saveStaticContent(contentForm);
  }

  uploadStaticContent(uploadDocument): Observable<any> {
    return this.dataSource.uploadStaticContent(uploadDocument);
  }
    
  getAllSuppliers(): Observable<SupplierDetails[]> {
    return this.dataSource.getAllSuppliers();
  }

  getSuppliersByUserId(cwsId : string): Observable<SupplierDetails[]> {
    return this.dataSource.getSuppliersByUserId(cwsId);
  }

  getWindchillFileDownload(filePath: string): Observable<any> {
    return this.dataSource.getWindchillFileDownload(filePath);
  }

  getWindchillSearch(textInfo: string, searchType: string): Observable<any> {
    return this.dataSource.getWindchillSearch(textInfo, searchType);
  }  

  searchWindchillRecord(textInfo: string, searchType: string): Observable<any> {
    return this.dataSource.searchWindchillRecord(textInfo, searchType);
  }
  
  getLogData(userAudit: UserAudit):Observable<any> {
    return this.dataSource.getLogData(userAudit);
  }
    // --------------------- ADMIN All Home Page Conents Methods End ----------------------  //
}
